module.exports = __webpack_public_path__ + "34bc775d/img/archive-icon.0a6a9de3.svg";